import styled from 'styled-components';

export const StyledRegisteredAppointmentsCardCount = styled.div`
   font-size: 48px;
   line-height: 28px;
`;
StyledRegisteredAppointmentsCardCount.displayName = 'StyledRegisteredAppointmentsCardCount';
